export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9295_MY_SCORECARDS': 'My Scorecards',
    '_9308_ESTIMATED_PAYOUT': 'Estimated Payout',
    '_9946_LAUNCH_SCORECARDS': 'Launch Scorecards',
    '_67_SUPERGROUP': 'SuperGroup',
    '_989_TREND': 'Trend',
    '_804_SUPERGROUP_': 'SuperGroup:',
    '_9947_SCORECARD_ID_': 'Scorecard ID:',
    '_9361_ADJUSTED_SCORE_': 'Adjusted Score',
    '_9360_ORIGINAL_SCORE_': 'Original Score',
    '_9948_ADD_RANK': 'Add Rank',
    '_9949_ADD_BONUS': 'Add Bonus',
    '_9856_SCORECARD_SCORE': 'Scorecard Score',
    '_9880_MI2_SCORECARD_CATEGORY': 'MI2 Scorecard Category',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_9951_MEETS': 'Meets',
    '_9402_NA': 'NA',
    '_11184_LAUNCH_TREND': 'Launch Trend',
    '_9980_LAUNCH_SCORECARD': 'Launch Scorecard',
    '_11185_RANKING': 'Ranking',
    '_11186___CHANGE': '% Change',
    '_11187_PREVIOUS_SCORE': 'Previous Score',
    '_11188_VIEW_PREVIOUS_SCORECARD': 'View Previous Scorecard',
    '_11189_VIEW_NEXT_SCORECARD': 'View Next Scorecard',
    '_11174_RESET_CARD': 'Reset Card',
    '_11175_COLLAPSE_CARD': 'Collapse Card',
    '_11176_EXPAND_CARD': 'Expand Card'
};
